import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API } from "../../api";
import config from "../../config";
import { store } from "../../store/store";
import { showLoader } from "../reducer/commonReducer";
export interface RoleState {
  dashBoardData: any;
  repairOrderSummary:any,
  totalCount: number;
  status: "idle" | "loading" | "failed";
}
const initialState: RoleState = {
  dashBoardData: [],
  repairOrderSummary:[],
  totalCount: 0,
  status: "idle",
};

export const getJobCardData = createAsyncThunk(
  "dashboard/GetJobCardStatus",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.PostForJobCard(
      `${config.BASE_URL}/Dashboard/GetJobCardStatus`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result;
  }
);
export const dashBoardListAsync = createAsyncThunk(
  "dashboard/getDashboardList",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL}/Dashboard/GetAppointmentSummary`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result;
  }
);

export const getRepairOrderSummary = createAsyncThunk(
  "dashboard/getRepairOrderSummaryList",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL}/Dashboard/GetRepairOrderSummary`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result;
  }
);
export const dashboardSlice: any = createSlice({
  name: "dashboardReducer",
  initialState,
  reducers: {
    addData: (state, action: PayloadAction<any>) => {
      return { ...state, [action.payload.key]: action.payload.value };
    },
    setDashBoardData: (state, action: PayloadAction<any>) => {
      return { ...state, dashBoardData: action };
    },
    setRepairOrderSummary: (state, action: PayloadAction<any>) => {
      return { ...state, repairOrderSummary: action };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dashBoardListAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(dashBoardListAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.dashBoardData = action.payload;
      })
      .addCase(dashBoardListAsync.rejected, (state) => {
        state.status = "failed";
        state.dashBoardData = null;
      })
      .addCase(getRepairOrderSummary.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getRepairOrderSummary.fulfilled, (state, action) => {
        state.status = "idle";
        state.repairOrderSummary = action.payload;
      })
      .addCase(getRepairOrderSummary.rejected, (state) => {
        state.status = "failed";
        state.repairOrderSummary = null;
      })

      .addCase(getJobCardData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getJobCardData.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(getJobCardData.rejected, (state) => {
        state.status = "failed";
      })
    
  },
});
export default dashboardSlice.reducer;
